import { createFileRoute } from '@tanstack/react-router';
import SEO from 'components/Seo/Seo';
import useAppLanguage from 'hooks/useAppLanguage';
import messages from '../../messages';
import { FiatDepositComponent } from './components/FiatDeposit';

export const Route = createFileRoute('/_authenticated/funds/deposit/fiat/')({
  component: FiatDeposit,
});

function FiatDeposit() {
  const language = useAppLanguage();
  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page="/funds/deposit/fiat"
      />
      <div className="px-6 py-4">
        <FiatDepositComponent />
      </div>
    </>
  );
}
